import * as React from "react";
import { getMemaSlug } from "@plinknz/tah-website-elements";
import { Page } from "../../page";

export const MemberPage = () => {
  const slug = getMemaSlug(window.location);
  return <Page suffix="Members" slugOverride={slug} memberPages />;
};
